import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MaybeData } from '../../../api/model/api.model'
import { CarrierData } from '../../../api/model/backend.model'
import {
  AccountOpportunityFilterOptionsDto,
  AccountOpportunityListItemDto,
} from '../../../api/generated/api.generated'
import {
  AccountMappingData,
  AccountOpportunityFilters,
  AccountOpportunityQuery,
} from '../../model/program-initiation.model'
import { ProgramInitiationHeaderComponent } from '../program-initiation-header/program-initiation-header.component'
import { ProgramInitiationFilterComponent } from '../program-initiation-filter/program-initiation-filter.component'
import {
  ProgramInitiationListComponent,
  ProgramInitiationPageChange,
  ProgramInitiationSortChange,
} from '../program-initiation-list/program-initiation-list.component'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-program-initiation',
  styleUrls: [`./program-initiation.component.scss`],
  templateUrl: `./program-initiation.component.html`,
  imports: [
    ProgramInitiationHeaderComponent,
    ProgramInitiationFilterComponent,
    ProgramInitiationListComponent,
  ],
})
export class ProgramInitiationComponent {
  @Input() name = 'Program Initiation'
  @Input() query: AccountOpportunityQuery
  @Input() rows: AccountOpportunityListItemDto[] | null
  @Input() totalCount: number | null
  @Input() loading: boolean | null
  @Input() emptyMessage: string | null
  @Input() filterOptions: AccountOpportunityFilterOptionsDto | null
  @Input() accountNameSuggestions: string[] | null
  @Input() accountMappings: AccountMappingData[] | null
  @Input() allCarriers: MaybeData<CarrierData[]> | null
  @Input() isSaving: boolean | null
  @Input() initiatingOppId: string | null
  @Input() showAll: boolean | null

  @Output() filtersChange = new EventEmitter<AccountOpportunityFilters>()
  @Output() accountNameSearch = new EventEmitter<string>()
  @Output() showAllChange = new EventEmitter<boolean>()
  @Output() sortChange = new EventEmitter<ProgramInitiationSortChange>()
  @Output() pageChange = new EventEmitter<ProgramInitiationPageChange>()
  @Output() initiate = new EventEmitter<AccountOpportunityListItemDto>()
  @Output() updateSFMapping = new EventEmitter<AccountMappingData>()
}
